export interface UserWeightConfig {
  active: boolean
  goalWeight: number
  weightLocked: boolean
}

export const distributeUserWeights = <T extends UserWeightConfig>(
  users: T[],
  distribute: boolean | null | undefined
): T[] => {
  if (!distribute) return users

  const result = users.reduce(
    (acc, user, index) => {
      if (user.active && user.goalWeight > 0) {
        acc.accWeights += 1
        user.weightLocked ? (acc.accWeights -= user.goalWeight) : (acc.usersUnlocked += 1)
      }
      if (index === users.length - 1 && acc.usersUnlocked > 0) {
        acc.accWeights = acc.accWeights / acc.usersUnlocked
      }
      return acc
    },
    { accWeights: 0, usersUnlocked: 0 }
  )

  return users.map(user => {
    if (user.active && !user.weightLocked) {
      return {
        ...user,
        goalWeight: result.accWeights < 0 ? 0 : result.accWeights
      }
    }
    return user
  })
}
